import { render, staticRenderFns } from "./checkout-local-delivery.vue?vue&type=template&id=90756f28"
import script from "./checkout-local-delivery.vue?vue&type=script&lang=js"
export * from "./checkout-local-delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackreeve/projects/logshed/wp-content/themes/logshed/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90756f28')) {
      api.createRecord('90756f28', component.options)
    } else {
      api.reload('90756f28', component.options)
    }
    module.hot.accept("./checkout-local-delivery.vue?vue&type=template&id=90756f28", function () {
      api.rerender('90756f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/checkout-local-delivery.vue"
export default component.exports